import * as React from 'react';
import { SVGProps } from 'react';

const IconMagicSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <path d="M17.97 8.1a.46.46 0 0 1 .861 0l1.934 5.227a4.585 4.585 0 0 0 2.71 2.709L28.7 17.97c.399.148.399.713 0 .861l-5.227 1.934a4.585 4.585 0 0 0-2.709 2.71L18.831 28.7a.46.46 0 0 1-.86 0l-1.935-5.227a4.585 4.585 0 0 0-2.709-2.709l-5.226-1.934a.46.46 0 0 1 0-.86l5.226-1.935a4.585 4.585 0 0 0 2.709-2.709l1.934-5.226ZM7.761 3.224c.111-.299.535-.299.646 0l.86 2.324a2.294 2.294 0 0 0 1.354 1.355l2.323.858c.3.111.3.535 0 .646l-2.323.86a2.293 2.293 0 0 0-1.354 1.354l-.86 2.323c-.11.3-.535.3-.646 0l-.858-2.323a2.294 2.294 0 0 0-1.355-1.354l-2.324-.86a.345.345 0 0 1 0-.646l2.324-.858a2.294 2.294 0 0 0 1.355-1.355l.858-2.324Z" />
  </svg>
);
export default IconMagicSizeL;
